import React from 'react';
import { PrivateRoute } from './PrivateRoute';
import ProtectedRoute from './ProtectedRoute';

/**
 * ponytail: one wrapper for layout + RBAC (+ optional feature flag via ProtectedRoute)
 */
export function AppRoute({
  pageName,
  featureFlag,
  featureRedirectTo = '/dashboard',
  hideLayout = false,
  excludeRoles,
  requiredFeature,
  children,
}) {
  return (
    <PrivateRoute hideLayout={hideLayout} excludeRoles={excludeRoles}>
      <ProtectedRoute
        pageName={pageName}
        featureFlag={featureFlag}
        featureRedirectTo={featureRedirectTo}
        requiredFeature={requiredFeature}
      >
        {children}
      </ProtectedRoute>
    </PrivateRoute>
  );
}
